import {
  RewardScheduleContentUpdateRequest,
  RewardScheduleWithGame,
  SpinToWinApi,
  RewardSchedulesWithGames,
  S2WGame,
  S2WGameUpdateRequest,
} from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

const getCurrent = async (): Promise<RewardSchedulesWithGames> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(SpinToWinApi)
  return await api.getCurrentRewardSchedules({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
  })
}

const updateContent = async (
  scheduleId: string,
  update: RewardScheduleContentUpdateRequest,
): Promise<RewardScheduleWithGame> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(SpinToWinApi)
  return await api.updateRewardScheduleContent({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    scheduleId,
    rewardScheduleContentUpdateRequest: update,
  })
}

const endEarly = async (scheduleId: string): Promise<void> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(SpinToWinApi)
  await api.endRewardScheduleEarly({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    scheduleId,
  })
}

const updateGame = async (gameId: string, update: S2WGameUpdateRequest): Promise<S2WGame> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(SpinToWinApi)
  return await api.updateS2WGame({
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
    gameId,
    s2WGameUpdateRequest: update,
  })
}

export const RewardSchedulesAPI = {
  getCurrent,
  updateContent,
  endEarly,
  updateGame,
}
